import { Table } from '@nextui-org/react';
import {Col, Row} from 'react-bootstrap';
import ProgressBar from 'react-bootstrap/ProgressBar';
import  './SkillCard.css';
import {Fragment} from "react";

export interface SkillColumnProps {
  title: string,
  skillSet: {name:string, rate: number}[]
}

const SkillCard = (props: { skills: SkillColumnProps }) => {
  const {title, skillSet} = props.skills;
  return (
    <div className="programming-skills">
      <h3>{title}</h3>
      {
        skillSet.map(skill => {
          return <div style={{textAlign:"center"}}>
              <h4 style={{fontSize:16}}>{skill.name}</h4>
            </div>
        })
      }
    </div>
  )
}

export default SkillCard;